import { DatePipe, SlicePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { first } from "rxjs";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { ConfigService } from "src/app/servicios/config/config.service";
@Component({
  selector: "app-post-listado",
  templateUrl: "./post-listado.component.html",
  styleUrls: ["./post-listado.component.css"],
  imports: [RouterLink, SlicePipe, DatePipe, KebabCasePipe],
})
export class PostListadoComponent implements OnInit {
  @Input() post;
  @Input() urlBlog;
  config: any;

  /**
   * The constructor function takes a ConfigService parameter and assigns it to the private property
   * configService.
   * @param {ConfigService} configService - The `configService` parameter is a private instance of the
   * `ConfigService` class that is being injected into the constructor of the current class. This
   * allows the class to access and utilize the functionality provided by the `ConfigService` class
   * within its own methods and properties.
   */
  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((result) => {
        this.config = result.general["app-logo-menu"];
      });
    }
  }

  formatDate(obj): string {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }
}
